module.exports = __webpack_public_path__ + "img/diagnosis-dialog-bg-1-2.a027779f.png";